import { Grid, GridColumn } from 'src/components/Reusable/Grid'
import palette from 'src/designSystem/variables/palette'
import styled from 'styled-components/macro'

export const StyledEvidenceColumn = styled(GridColumn)`
  &:hover {
    cursor: pointer;
  }
  white-space: nowrap;
`

export const StyledActionEvidenceColumn = styled(StyledEvidenceColumn)`
  justify-content: right;
`

export const StyledEvidenceGrid = styled(Grid)`
  a.grid-column {
    text-decoration: none;
    color: ${palette.neutral[900]};
  }
`
